import { render } from "./WorkExperience.vue?vue&type=template&id=2459c39c&scoped=true"
import script from "./WorkExperience.vue?vue&type=script&lang=js"
export * from "./WorkExperience.vue?vue&type=script&lang=js"

import "./WorkExperience.vue?vue&type=style&index=0&id=2459c39c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2459c39c"]])

export default __exports__